// extracted by mini-css-extract-plugin
module.exports = {"productLabels":"ProductLabels_productLabels__eXtuG","productLabel":"ProductLabels_productLabel__4dI7u"};